import React from 'react';

import { studentMessages } from '../../../../translates/studentMessages';
import { NotificationBar } from '../../../components/notification/NotificationBar';
import { useIntlReexport } from '../../../hooks/useIntlReexport';

export interface NoHotspotNotificationProps {
  shouldDisplay: boolean;
}

export const NoHotspotNotification: React.FC<NoHotspotNotificationProps> = (props: NoHotspotNotificationProps) => {
  const { formatMessage } = useIntlReexport();
  return props.shouldDisplay ? <NotificationBar text={formatMessage(studentMessages.emptyContent)} /> : null;
};
